import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';
import { ReservationRepository } from '../repositories/reservation.respository';
import { GetReservationParams } from '../models/reservation-response';

export class GetReservationUseCase implements UseCase<any, any> {
    constructor(private readonly repository: ReservationRepository) {}

    execute(params: GetReservationParams): Observable<any> {
        return this.repository.getReservation(params);
    }
}
